import { Action } from '@ngrx/store';
import { UserSessionSettingsInterface } from 'app/site-settings/models/usersession-settings.model';

import { SiteSettingActionType } from './site-setings-action-type.enum';

export class LoadUserSessionSettings implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadUserSessionSettings;

  // public readonly payload: any = undefined;
  constructor(public readonly payload: number) { }
}

export class LoadUserSessionSettingsCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadUserSessionSettingsCompleted;

  constructor(public readonly payload: UserSessionSettingsInterface) { }
  // constructor(public readonly payload: number) { }
}

export class LoadUserSessionnSettingsFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadUserSessionSettingsFailed;

  constructor(public readonly payload: string) { }
}
export class UpdateUserSessionSettings implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateUserSessionSettings;

  constructor(public readonly payload: UserSessionSettingsInterface) {  }
}

export class UpdateUserSessionSettingsCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateUserSessionSettingsCompleted;

  constructor(public readonly payload: UserSessionSettingsInterface) { }
}

export class UpdateUserSessionSettingsFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateUserSessionSettingsFailed;

  constructor(public readonly payload: string) { }
}
